import { Subtitle1 } from "@fluentui/react-components";
import { CSSProperties } from "react";

export const ErrorPage = (): JSX.Element => {
    const footerLinkStyle: CSSProperties = {
        color: "rgb(3, 159, 184)",
        textDecoration: "underline",
        cursor: "pointer"
    };

    return (
        <div className="App" style={{
            flexDirection: "row",
            display: "flex",
            height: "100vh",
            justifyContent: "center"
        }}>
            <Subtitle1>
                Please wait a moment while we securely log you into the system. If you encounter any issues or need assistance, our support team is available at{" "}
                <a
                    style={footerLinkStyle}
                    href="mailto:nhhelpu@northhighland.com"
                    onMouseOver={(e) => (e.currentTarget.style.textDecoration = "none")}
                    onMouseOut={(e) => (e.currentTarget.style.textDecoration = "underline")}
                >
                    nhhelpu@northhighland.com
                </a>.
            </Subtitle1>
        </div>
    );
};